const BillingStatusOptions = [
   {
      value: 'Active',
      label: 'Active',
      id: 1,
   },
   {
      value: 'Disabled',
      label: 'Disabled',
      id: 2,
   },
];

export default BillingStatusOptions;
